import styled from "styled-components";
import { breakpoints } from './constants';

const Selected = styled.div`
  position: relative;
  z-index: 2;
  padding: 0 10px;
  cursor: pointer;
  font-weight: 700;
  font-family: 'Nunito', sans-serif;
  p {
    font-size: 13px;
  }
  @media (min-width: ${breakpoints.tablet}) {
    p {
      font-size: 16px;
    }
  }
`;

export default Selected;



// WEBPACK FOOTER //
// ./src/styled-components/Selected.js